"use strict";

exports.__esModule = true;
exports["default"] = exports.AccordionLabel = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ramda = require("ramda");

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _elements = require("../glyphs/elements");

var _accordionItem = _interopRequireDefault(require("../accordion/accordion-item"));

var _utils = require("../../utils");

var _accordionItems = _interopRequireDefault(require("./accordion-items"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var propTypes = {
  /** Object map of filters currently active */
  activeFilters: (0, _propTypes.objectOf)(_propTypes.bool),
  // Object map of filters currently disabled
  disabledFilters: (0, _propTypes.objectOf)(_propTypes.bool),

  /** onChange event handler - used to process the filter selection event */
  filterOnChange: _propTypes.func,
  // Object map of all filters active
  filters: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number])
  })),

  /** Label for filters group */
  label: _propTypes.string,
  // Font for Label for filters group
  labelFont: _utils.fontPropType,
  // Total Filter to show
  maxFiltersToShow: _propTypes.number,
  // Callback to handle more button click event
  moreButtonOnClick: _propTypes.func
};
var defaultGroupLabelFont = {
  color: "text-title",
  fontSize: 2,
  fontWeight: [2, 2, 1],
  letterSpacing: "0.5px",
  lineHeight: 2
};
var filtersCountFont = {
  color: "text-light",
  fontSize: "8px",
  fontWeight: 2,
  lineHeight: 0
};
var NumberContainer = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "filters-accordion__NumberContainer",
  componentId: "sc-9hwml3-0"
})(["vertical-align:top;"]);
var labelPropTypes = {
  isOpen: _propTypes.bool,
  label: _propTypes.node,
  numberFilters: _propTypes.number
};

var AccordionLabel = function AccordionLabel(_ref) {
  var numberFilters = _ref.numberFilters,
      isOpen = _ref.isOpen,
      label = _ref.label;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, label, " ", !isOpen && numberFilters ? /*#__PURE__*/_react["default"].createElement(NumberContainer, {
    alignItems: "center",
    backgroundColor: "secondary-blue",
    borderRadius: "50%",
    display: "inline-flex",
    forwardedAs: "span",
    height: 16,
    justifyContent: "center",
    width: 16
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, _extends({
    tag: "span"
  }, filtersCountFont), numberFilters)) : null);
};

exports.AccordionLabel = AccordionLabel;
AccordionLabel.propTypes = labelPropTypes;
AccordionLabel.displayName = "Modules.AccordionLabel";
var defaultProps = {
  activeFilters: {},
  disabledFilters: {},
  filters: []
};

var FiltersAccordion = function FiltersAccordion(_ref2) {
  var activeFilters = _ref2.activeFilters,
      disabledFilters = _ref2.disabledFilters,
      filterOnChange = _ref2.filterOnChange,
      filters = _ref2.filters,
      label = _ref2.label,
      _ref2$labelFont = _ref2.labelFont,
      labelFont = _ref2$labelFont === void 0 ? defaultGroupLabelFont : _ref2$labelFont,
      maxFiltersToShow = _ref2.maxFiltersToShow,
      moreButtonOnClick = _ref2.moreButtonOnClick;

  var _useToggle = (0, _utils.useToggle)(false, moreButtonOnClick),
      isExpanded = _useToggle[0],
      showMoreOnClick = _useToggle[1];

  var _useToggle2 = (0, _utils.useToggle)(true),
      isOpen = _useToggle2[0],
      accordionOnClick = _useToggle2[1];

  var showMoreButton = (0, _ramda.length)(filters) > maxFiltersToShow;
  var numberFilters = (0, _ramda.length)((0, _ramda.keys)(activeFilters));
  var visibleFilters = (0, _ramda.take)(!isExpanded ? maxFiltersToShow : Infinity, filters) || [];
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    borderBottom: ["solid 1px", "solid 1px", "none"],
    borderBottomColor: ["gray-divider", "gray-divider"],
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_accordionItem["default"], {
    glyph: /*#__PURE__*/_react["default"].createElement(_elements.NavCaretDown, null),
    glyphSize: 12,
    isOpen: isOpen,
    label: /*#__PURE__*/_react["default"].createElement(AccordionLabel, {
      isOpen: isOpen,
      label: label,
      numberFilters: numberFilters
    }),
    labelFont: labelFont,
    onItemClick: accordionOnClick
  }, /*#__PURE__*/_react["default"].createElement(_accordionItems["default"], {
    activeFilters: activeFilters,
    disabledFilters: disabledFilters,
    filterOnChange: filterOnChange,
    isExpanded: isExpanded,
    isOpen: isOpen,
    showMoreButton: showMoreButton,
    showMoreOnClick: showMoreOnClick,
    visibleFilters: visibleFilters
  })));
};

FiltersAccordion.propTypes = propTypes;
FiltersAccordion.defaultProps = defaultProps;
FiltersAccordion.displayName = "Modules.FiltersAccordion";
var _default = FiltersAccordion;
exports["default"] = _default;